import { createSlice } from "@reduxjs/toolkit";
import { setNewsletter, setLanguage } from "../Utilities/apiUtil";
import { get_req, post_req } from "../Utilities/apiUtil";
import {
  set_newsletter_request_url,
  init_request_url,
  set_birth_date_url,
  get_thanks_page_status_request_url,
} from "../Utilities/apiUrl";
import { errorActions } from "./errorSlice";
import { loaderActions } from "./loaderSlice";
import appConst from "../Utilities/appConst.json";
import { basketActions } from "../store/basket";
import { personalDetailsActions } from "./personalDetailsSlice";

export const getNewsletterData = (lang) => {
  return async (dispatch) => {
    try {
      if (lang) {
        setLanguage(lang);
      }
      const newsletter = await get_req(init_request_url);

      switch (newsletter.errorCode) {
        case appConst.ERROR_NO_ITEMS_IN_BASKET:
          dispatch(errorActions.setBasketEmpty(true));
          dispatch(loaderActions.loaderHide());
          break;
        case 0: // need to change to default error
          if (newsletter.isValid) {
            dispatch(userActions.setUserData(newsletter));
            dispatch(basketActions.setFrames(newsletter.payload.FramesUrl));
            dispatch(
              basketActions.setTilesQuantityStripText(
                newsletter.payload.QuentityTiles
              )
            );
            dispatch(
              personalDetailsActions.setSenderPersonalDetails({
                ...newsletter.payload.PersonalDetails,
                phoneNumber:
                  newsletter.payload.PersonalDetails.phoneNumber?.slice(3) ||
                  "",
                areaCode:
                  newsletter.payload.PersonalDetails.phoneNumber?.slice(0, 3) ||
                  "",
              })
            );
          } else {
            dispatch(errorActions.setError(true));
          }
          break;
        default:
          dispatch(errorActions.setError(true));
      }
    } catch (error) {
      dispatch(errorActions.setError(true));
    }
  };
};

// Tracks the in-flight set_newsletter save so downstream reads (get_delivery) can
let newsletterSave = Promise.resolve();
export const whenNewsletterSaved = () => newsletterSave;

export const postNewsletterData = (isNewsletterChecked) => {
  return async (dispatch) => {
    const save = (async () => {
      try {
        const data = await get_req(
          `${set_newsletter_request_url}&newsletter=${isNewsletterChecked}`
        );
        dispatch(errorActions.setError(!data.isValid));
        return data;
      } catch (error) {
        dispatch(errorActions.setError(true));
      }
    })();
    newsletterSave = save;
    return save;
  };
};
export const getThanksPageStatus = () => {
  return async (dispatch) => {
    try {
      const data = await get_req(`${get_thanks_page_status_request_url}`);
      dispatch(userActions.setUserThankYouPageStatus(data.payload));
      return data;
    } catch (error) {
      dispatch(errorActions.setError(true));
    }
  };
};

export const setBirthDate = (birthDate) => {
  return (dispatch) => {
    dispatch(userActions.setUserBirthDate(birthDate));
    // Return the promise so callers can await the save before navigating away.
    return get_req(`${set_birth_date_url}&${birthDate}`).catch((error) => {
      dispatch(errorActions.setError(true));
    });
  };
};


const setMarketingImages = (marketingImages) => {
  // const firstImage =  /\/(\w+)\.png/.exec(marketingImages[0].image);

  const birthdayItem = marketingImages.filter((marketingImage) =>
    marketingImage.image ? marketingImage.image.includes(appConst.BIRTHDAY) : []
  );
  const newsletterItem = marketingImages.filter((marketingImage) =>
    marketingImage.image
      ? marketingImage.image.includes(appConst.NEWSLETTER)
      : []
  );
  const couponItem = marketingImages.filter((marketingImage) =>
    marketingImage.image ? marketingImage.image.includes(appConst.COUPON) : []
  );
  const generic1Item = marketingImages.filter((marketingImage) =>
    marketingImage.image ? marketingImage.image.includes(appConst.GENERIC1) : []
  );
  const generic2Item = marketingImages.filter((marketingImage) =>
    marketingImage.image ? marketingImage.image.includes(appConst.GENERIC2) : []
  );

  // priority: 0 is the heighest
  const items = [
    { item: birthdayItem[0], priority: 0 },
    { item: newsletterItem[0], priority: 1 },
    { item: couponItem[0], priority: 2 },
    { item: generic1Item[0], priority: 3 },
    { item: generic2Item[0], priority: 4 },
  ];

  return items.filter((obj) => obj.item).map((obj) => obj.item);
};

const userSlice = createSlice({
  name: "user",
  initialState: {
    isNewsletter: false,
    isAuthCoupon: false,
    isBirthdayDate: false,
    isCollectionBucket: false,
    personalDetails: null,
    stocks: [],
    marketingImages: null,
    birthDate: null,
    thankYouPageStatus: null,
    calendarFormats: null,
  },
  reducers: {
    getnewsletter: (state, action) => {
      return state;
    },
    setUserData: (state, action) => {
      state.isNewsletter = action.payload.payload.IsNewsletter;
      state.isAuthCoupon = action.payload.payload.IsAuthCoupon;
      state.isBirthdayDate = action.payload.payload.IsBirthdayDate;
      state.isCollectionBucket = action.payload.payload.IsCollectionBucket;
      state.personalDetails = action.payload.payload.PersonalDetails;
      state.stocks = [...action.payload.payload.stocks_availability];
      state.marketingImages = setMarketingImages([
        ...action.payload.payload.MarketingImages,
      ]);
      state.thankYouPageStatus = action.payload.payload.thankYouPageStatus;
      state.calendarFormats = action.payload.payload.CalendarFormats;
    },
    setUserDataFromPersonalDetails: (state, action) => {
      state.personalDetails = action.payload;
    },
    setUserBirthDate: (state, action) => {
      state.birthDate = action.payload || null;
    },
    setUserThankYouPageStatus: (state, action) => {
      state.thankYouPageStatus = [...action.payload] || [];
    },
    setNewsletter: (state, action) => {
      state.isNewsletter = action.payload;
      setNewsletter(action.payload);
    },
  },
});

export const userActions = userSlice.actions;
export default userSlice;
